import { GridInputs } from "../../../../../components/Functional";

const SORT_OPTIONS = [
  { label: "Company", value: "company" },
  { label: "County", value: "county" },
  { label: "Country", value: "country" },
  { label: "Surname", value: "surname" },
  { label: "Job Title", value: "title" },
  { label: "City", value: "city" },
  { label: "First Sales User", value: "salesUserId" },
  { label: "Second Sales User", value: "salesUser2Id" },
  { label: "Type", value: "typeId" },
  { label: "Total Spend", value: "totalSpend" },
];

const OPERATOR_OPTIONS = [
  { label: "Ascending", value: "ASC" },
  { label: "Descending", value: "DESC" },
];

const getSortInputs = ({ formik } = {}) => ({
  className: "grid grid-rows-2 gap-4",
  inputs: [
    {
      className: "grid grid-cols-4 gap-4",
      inputs: [
        {
          hasOperator: true,
          label: "Sort By 1st",
          name: "sort1",
          options: SORT_OPTIONS.filter(
            option =>
              ![
                formik?.values?.sort2?.value,
                formik?.values?.sort3?.value,
              ].includes(option.value),
          ),
          operatorOptions: OPERATOR_OPTIONS,
          type: "multi-select",
        },
        {
          hasOperator: true,
          label: "Sort By 2nd",
          name: "sort2",
          options: SORT_OPTIONS.filter(
            option =>
              ![
                formik?.values?.sort1?.value,
                formik?.values?.sort3?.value,
              ].includes(option.value),
          ),
          operatorOptions: OPERATOR_OPTIONS,
          type: "multi-select",
        },
        {
          hasOperator: true,
          label: "Sort By 3rd",
          name: "sort3",
          options: SORT_OPTIONS.filter(
            option =>
              ![
                formik?.values?.sort1?.value,
                formik?.values?.sort2?.value,
              ].includes(option.value),
          ),
          operatorOptions: OPERATOR_OPTIONS,
          type: "multi-select",
        },
        {
          label: "limit",
          name: "limit",
          onChange: e => {
            const { value } = e.target;
            formik?.setFieldValue("limit", parseInt(value) || 10);
          },
          type: "number",
        },
      ],
    },
  ],
});

const Sort = props => {
  const { formik } = props || {};

  const inputs = getSortInputs({ formik });

  return <GridInputs formik={formik} {...inputs} />;
};

export default Sort;
export { getSortInputs };
